import React from "react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import ContentCard from "../../../common/components/ContentCard/ContentCard";
import CountryPriceTables from "./CountryPricingTablesV2"

export default class PricingDetailPageInfo extends React.Component {

    static propTypes = {
        pricingTableDetailsV2: PropTypes.object,
        pricingTableTenants: PropTypes.array,
        countryPriceTables: PropTypes.object,
        editButton: PropTypes.func,
        deleteButton: PropTypes.func,
        canEdit: PropTypes.bool,
    }

    render() {
        const {
            pricingTableDetailsV2, pricingTableTenants, basePrice,
            countryPriceTables, editButton, deleteButton, canEdit
        } = this.props;
        return (
            <ContentCard
                headerContent={"Pricing Details"}
                hasCRUDButtons={!!canEdit}
                hasAddButton={false}
                hasCloneButton={false}
                hasDeleteButton={!pricingTableTenants.length}
                onClickEdit={editButton}
                onClickDelete={deleteButton}
            >
                <dl className={"description-list"}>
                    <div>
                        <dt>Description:</dt>
                        <dd dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pricingTableDetailsV2.description) }}></dd>
                    </div>
                    <div className={"break"}></div>
                    <div>
                        <dt>Currency:</dt>
                        <dd>{pricingTableDetailsV2.currency}</dd>
                        <div className={"break"}></div>
                        <dt>Pricing Type:</dt>
                        <dd>{pricingTableDetailsV2.pricing_type}</dd>
                        <div className={"break"}></div>
                        <dt>Base Price:</dt>
                        <dd>{basePrice}</dd>
                    </div>
                    <div>
                        <dt style={{width: '150px'}}>Volume Aggregation:</dt>
                        <dd>{pricingTableDetailsV2.volume_aggregation_type}</dd>
                    </div>
                </dl>

                <CountryPriceTables
                    pricingID={pricingTableDetailsV2.pricing_id}
                    countryPriceTables={countryPriceTables}
                />

            </ContentCard>
        )
    }
}
